import { useActivityContext } from "@/modules/lead-page/new/hooks/activity-context.hook";

const useActivityTimeline = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    fetchPreviousPage,
    hasPreviousPage,
    isFetchingPreviousPage,
    isFetching,
    isLoading,
    isError,
    isFindingActivity,
  } = useActivityContext();

  // Remove duplicate records that may overlap across pages
  const allItems = (() => {
    const seen = new Set<string>();
    return (data?.pages.flatMap((page) => page.data.items) ?? []).filter(
      (item) => {
        const key = `${item.id}-${item.uid}`;
        return !seen.has(key) && seen.add(key);
      },
    );
  })();

  const hasChild = data?.pages[0]?.data?.hasChild ?? false;

  const count = data?.pages[0]?.data.count ?? 0;
  const isEmpty = allItems.length === 0;

  const mostRecentActivityItem =
    allItems.length > 0
      ? [...allItems].sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        )[0]
      : undefined;

  return {
    allItems,
    mostRecentActivityItem,
    count,
    hasChild,
    isEmpty,
    isLoading: isLoading || isFindingActivity, // Combine both loading states
    isFetching,
    isError,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    hasPreviousPage,
    fetchPreviousPage,
    isFetchingPreviousPage,
  };
};

export default useActivityTimeline;
